module.exports = __webpack_public_path__ + "img/4.17cf39ab.jpg";